export const CHANNEL = 'SEARCH_MASK';
